// Japanese (ja-JP) translations.
// Keys must exactly match ko.ts. Missing keys fall back to ko-KR at runtime.

const ja = {
  'nav.home_label': 'ホームダッシュボードへ',
  'nav.expand': 'メニューを開く',
  'nav.collapse': 'メニューを閉じる',
  'nav.api_connected': 'API 接続中',

  'nav.group.business': 'Business',
  'nav.group.manufacturing': 'Manufacturing',
  'nav.group.field': 'Field',
  'nav.group.admin': 'Admin',

  'nav.item.customer_master': '顧客マスター',
  'nav.item.customer_documents': '顧客書類',
  'nav.item.inbound': 'インバウンド状況(自動)',
  'nav.item.demo_conversion': 'デモ→契約転換',
  'nav.item.inquiry': '導入問い合わせ状況(手入力)',
  'nav.item.deals': '営業パイプライン',
  'nav.item.contracts': '契約',
  'nav.item.stores': '店舗',
  'nav.item.robots': 'ロボット',
  'nav.item.reports': 'レポート受信箱',
  'nav.item.service_orders': 'サービスオーダー',
  'nav.item.triage_queue': 'トリアージキュー',
  'nav.item.infrastructure': 'カレンダー · インフラ発注',
  'nav.item.fleet_tracker': '追跡・分析',
  'nav.item.privacy_requests': 'DSAR 受信箱',
  'nav.item.audit_logs': '監査ログ',
  'nav.item.users': 'ユーザー',
  'nav.item.incomplete_records': '未入力受信箱',
  'nav.item.option_groups': 'オプショングループ',
  'nav.item.retire_candidates': '回収検討',
  'nav.item.self_check_logs': 'セルフチェックログ',
  'nav.item.production_plan': '製造計画',
  'nav.item.assignments': 'ロボット割当',
  'nav.item.install_calendar': '設置スケジュール',

  'topbar.logout': 'ログアウト',

  'role.admin': '管理者',
  'role.manager': 'マネージャー',
  'role.sales_manager': '営業チームマネージャー',
  'role.mfg_manager': '製造チームマネージャー',
  'role.field_manager': 'フィールドチームマネージャー',
  'role.viewer': 'ビューアー',

  'owner.honeycomb_robotics': 'ハニカムロボティクス',
  'owner.beyond_honeycomb': 'ビヨンドハニカム',

  'locale.ko': '한국어',
  'locale.ja': '日本語',
  'locale.zh': '简体中文',

  'common.loading': '読み込み中…',
  'common.no_results': '結果なし',
  'common.error_load': 'データを読み込めませんでした',
  'common.cancel': 'キャンセル',
  'common.confirm': '確認',
  'common.save': '保存',
  'common.delete': '削除',
  'common.edit': '編集',
  'common.close': '閉じる',
  'common.submit': '送信',
  'common.processing': '処理中…',
  'common.search_placeholder': '検索…',
  'common.all': 'すべて',
  'common.none': 'なし',
  'common.yes': 'はい',
  'common.no': 'いいえ',
  'common.items_count': '{count, number}件',
  'common.page_of': '{page} / {total}',
  'common.prev': '前へ',
  'common.next': '次へ',
  'common.csv_export': 'CSV エクスポート',
  'common.exporting': 'エクスポート中…',
  'common.assign_me': '自分に割り当て',
  'common.assigned_to_me': '自分に割り当て済み',
  'common.open_only': '未完了のみ',
  'common.unresolved_only': '未解決のみ',
  'common.update_failed': '更新に失敗しました',
  'common.danger_irreversible': 'この操作は元に戻せません。',

  'entity.honeycomb_robotics': 'ハニカムロボティクス',
  'entity.beyond_honeycomb': 'ビヨンドハニカム',

  'so.page_title': 'サービスオーダー受信箱',
  'so.triage_title': 'サービスオーダートリアージキュー',
  'so.new_title': 'サービスオーダー新規登録',
  'so.empty': '処理中のサービスオーダーはありません',
  'so.empty_sub': '新しい受付が入るとここに表示されます。',
  'so.select_prompt': 'サービスオーダーを選択してください。',

  'so.col.status': 'ステータス',
  'so.col.category': 'カテゴリ',
  'so.col.robot': 'ロボット',
  'so.col.customer': '顧客',
  'so.col.assignee': '担当者',
  'so.col.created': '受付時刻',
  'so.col.sla': 'SLA',

  'so.status.open': '新規',
  'so.status.triaged': 'トリアージ済み',
  'so.status.assigned': '割り当て済み',
  'so.status.in_progress': '進行中',
  'so.status.blocked': '待機中',
  'so.status.resolved': '解決済み',
  'so.status.verified': '検証済み',
  'so.status.closed': '完了',
  'so.status.cancelled': 'キャンセル',

  'so.category.preventive': '予防点検',
  'so.category.reactive': '障害対応',
  'so.category.install': '設置',
  'so.category.removal': '撤去',
  'so.category.parts_swap': '部品交換',

  'so.action.triage': 'トリアージ',
  'so.action.assign_me': '自分に割り当て＆確認',
  'so.action.transition': 'ステータス変更',
  'so.action.cancel': 'キャンセル',
  'so.action.restore': '復元',
  'so.action.reassign_customer': '顧客再割り当て',
  'so.action.resolve': '解決',

  'so.cancel_reason_required': 'キャンセル理由（必須）',
  'so.cancel_confirm_title': 'サービスオーダーのキャンセル',
  'so.restore_confirm_title': 'サービスオーダーの復元',
  'so.restore_confirm_msg': 'このサービスオーダーを復元しますか？',

  'reports.page_title': 'レポート受信箱',
  'reports.empty': '未処理のレポートはありません',
  'reports.empty_sub': '顧客がQRをスキャンしてレポートを送ると、ここに表示されます。',
  'reports.select_prompt': 'レポートを選択してください。',

  'reports.col.urgency': '緊急度',
  'reports.col.id': 'ID',
  'reports.col.status': 'ステータス',
  'reports.col.robot': 'ロボット',
  'reports.col.category': 'カテゴリ',
  'reports.col.preview': 'プレビュー',
  'reports.col.submitted_at': '送信日時',

  'reports.status.new': '新規',
  'reports.status.triaged': 'トリアージ済み',
  'reports.status.assigned': '割り当て済み',
  'reports.status.in_progress': '進行中',
  'reports.status.resolved': '解決済み',
  'reports.status.dismissed': '却下',
  'reports.status.duplicate': '重複',

  'reports.severity.urgent': '緊急',
  'reports.severity.normal': '通常',
  'reports.urgency_filter.urgent_only': '緊急のみ',
  'reports.urgency_filter.normal_only': '通常のみ',

  'reports.category.hardware_failure': 'ハードウェア故障',
  'reports.category.cooking_quality': '調理品質',
  'reports.category.cleaning_hygiene': '清掃・衛生',
  'reports.category.dispensing': '供給・排出',
  'reports.category.connectivity': '通信',
  'reports.category.ui_ux': 'UI',
  'reports.category.other': 'その他',

  'reports.detail.category': 'カテゴリ',
  'reports.detail.urgency': '緊急度',
  'reports.detail.robot': 'ロボット',
  'reports.detail.store': '店舗',
  'reports.detail.contact': '連絡先',
  'reports.detail.description': '詳細内容',
  'reports.detail.current_status': '現在のステータス',

  'reports.action.assign_me': '自分に割り当て',
  'reports.action.in_progress': '進行中',
  'reports.action.resolve': '解決',
  'reports.action.dismiss': '却下',
  'reports.action.resolve_label': '解決',
  'reports.action.dismiss_label': '却下',

  'reports.modal.resolve_title': 'レポートの解決',
  'reports.modal.resolve_note_label': '解決メモ',
  'reports.modal.resolve_note_required': '解決メモ（必須）',
  'reports.modal.dismiss_title': 'レポートの却下',
  'reports.modal.dismiss_reason_label': '却下理由',
  'reports.modal.dismiss_reason_required': '却下理由（必須）',

  'dsar.page_title': '個人情報リクエスト (DSAR) 受信箱',
  'dsar.empty': '未処理のDSARリクエストはありません',
  'dsar.empty_sub': '顧客が /privacy/request から送信するとここに表示されます。',
  'dsar.select_prompt': 'リクエストを選択してください。',

  'dsar.status.received': '受付済み',
  'dsar.status.in_review': '確認中',
  'dsar.status.fulfilled': '処理完了',
  'dsar.status.rejected': '却下',

  'dsar.type.access': '閲覧',
  'dsar.type.correction': '訂正',
  'dsar.type.deletion': '削除',
  'dsar.type.restriction': '処理停止',
  'dsar.type.other': 'その他',

  'dsar.col.sla': 'SLA',
  'dsar.col.id': '受付番号',
  'dsar.col.status': 'ステータス',
  'dsar.col.type': '種別',
  'dsar.col.locale': '言語',
  'dsar.col.subject': '申請者',
  'dsar.col.preview': 'プレビュー',
  'dsar.col.submitted_at': '送信日時',

  'dsar.locale.ko': '한국어',
  'dsar.locale.en': 'English',
  'dsar.locale.zh': '简体中文',

  'dsar.detail.current_status': '現在のステータス',
  'dsar.detail.id': '受付番号',
  'dsar.detail.type': '種別',
  'dsar.detail.locale': '言語',
  'dsar.detail.subject': '申請者',
  'dsar.detail.contact': '連絡先',
  'dsar.detail.related_report': '関連レポート',
  'dsar.detail.assignee': '担当者',
  'dsar.detail.fulfilled_at': '完了日時',
  'dsar.detail.description': 'リクエスト内容',
  'dsar.detail.review_note': '確認メモ',
  'dsar.detail.rejected_reason': '却下理由',

  'dsar.action.assign_review': '自分に割り当て＆確認',
  'dsar.action.fulfill': '処理完了',
  'dsar.action.reject': '却下',
  'dsar.modal.fulfill_title': 'DSAR 処理完了',
  'dsar.modal.fulfill_note_label': '確認メモ（任意）',
  'dsar.modal.reject_title': 'DSAR 却下',
  'dsar.modal.reject_reason_label': '却下理由（必須）',

  'dsar.sla.badge': '30d↑',
  'dsar.sla.exceeded': 'SLA 超過',

  'audit.page_title': '監査ログ',
  'audit.empty': '一致する監査ログがありません',
  'audit.empty_sub': 'フィルターを調整するか、「すべて」プリセットで開始してください。',
  'audit.select_prompt': '行を選択すると詳細が表示されます。',

  'audit.filter.action': 'アクション',
  'audit.filter.action_placeholder': '例: robot.create, auth.*',
  'audit.filter.resource_type': 'リソースタイプ',
  'audit.filter.resource_type_placeholder': '例: Robot, CustomerReport',
  'audit.filter.resource_id': 'リソース ID',
  'audit.filter.resource_id_placeholder': 'cuid / displayId',
  'audit.filter.entity': '法人',
  'audit.filter.outcome': '結果',
  'audit.filter.from_date': '開始日',
  'audit.filter.to_date': '終了日',

  'audit.preset.all': 'すべて',
  'audit.preset.auth': '認証',
  'audit.preset.robot': 'ロボット',
  'audit.preset.qr': 'QR',
  'audit.preset.deployment': '配備',
  'audit.preset.report': 'レポート',
  'audit.preset.dsar': 'DSAR',
  'audit.preset.user': 'ユーザー',

  'audit.col.time': '日時',
  'audit.col.action': 'アクション',
  'audit.col.resource': 'リソース',
  'audit.col.actor': '操作者',
  'audit.col.entity': '法人',
  'audit.col.outcome': '結果',

  'audit.outcome.success': '成功',
  'audit.outcome.failure': '失敗',
  'audit.outcome.failure_badge': '失敗',

  'audit.detail.id': 'ID',
  'audit.detail.time': '日時',
  'audit.detail.action': 'アクション',
  'audit.detail.resource': 'リソース',
  'audit.detail.resource_id': 'リソース ID',
  'audit.detail.actor': '操作者',
  'audit.detail.entity': '法人',
  'audit.detail.outcome': '結果',
  'audit.detail.ip': 'IP',
  'audit.detail.request_id': 'リクエスト ID',
  'audit.detail.error': 'エラーメッセージ',
  'audit.detail.diff': 'ペイロード (diff)',
  'audit.detail.user_agent': 'User-Agent',
  'audit.detail.system_anonymous': 'system / anonymous',
} as const;

export default ja;
